export default __webpack_public_path__ + "static/media/stop-covid-full.59b9228e.svg";